import newSyncRequestOperation from 'owa-service/lib/operation/newSyncRequestOperation';
import NewSyncRequestRequest from 'owa-service/lib/contract/NewSyncRequestRequest';
import NewSyncRequestResponse from 'owa-service/lib/contract/NewSyncRequestResponse';
import NewSyncRequestData from 'owa-service/lib/contract/NewSyncRequestData';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';

export async function newSyncRequest(syncRequest: NewSyncRequestData) {
    let request: NewSyncRequestRequest = {
        Header: getJsonRequestHeader(),
        SyncRequest: syncRequest,
    };

    let response: NewSyncRequestResponse = await newSyncRequestOperation(request);
    return response;
}
